import React from 'react';
import { Loader2, Save } from 'lucide-react';
import FilterDropdown from '../FilterDropdown';

// Page header: active-filter dropdown (with its rename / duplicate / delete /
// pin actions) plus the debounced auto-save indicator.
export const JobListHeader = ({
    savedFiltersList,
    activeFilterId,
    editingFilterName,
    isSavingFilter,
    onSelect,
    onCreate,
    onTogglePin,
    onRename,
    onDuplicate,
    onDelete,
    canSaveAsFilter,
    onSaveAsFilter,
}) => (
    <header className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="relative inline-block group">
            <FilterDropdown
                filters={savedFiltersList}
                activeFilterId={activeFilterId}
                activeFilterName={editingFilterName}
                onSelect={onSelect}
                onCreate={onCreate}
                onTogglePin={onTogglePin}
                onRename={onRename}
                onDuplicate={onDuplicate}
                onDelete={onDelete}
            />
        </div>
        <p className="text-gray-500 mt-1">Latest opportunities</p>

        <div className="flex items-center gap-3">
            {isSavingFilter && (
                <span className="text-xs text-gray-400 flex items-center gap-1">
                    <Loader2 className="w-3 h-3 animate-spin" /> Saving…
                </span>
            )}
            {canSaveAsFilter && (
                <button
                    type="button"
                    onClick={onSaveAsFilter}
                    className="flex items-center gap-1.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 px-3 py-1.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
                >
                    <Save size={15} />
                    Save as filter
                </button>
            )}
        </div>
    </header>
);
